import MensurationsRepository from "./lib/MensurationsRepository";
import AuthRepository from "./lib/AuthRepository";
import MenagementsRepository from "./lib/MenagementsRepository";
import ComunicationsRepository from "./lib/ComunicationsRepository";
import UserRepository from "./lib/UserRepository";
import ReportRepository from "./lib/ReportRepository";
import RecordRepository from "./lib/RecordRepository";

export {
	MensurationsRepository,
	AuthRepository,
	MenagementsRepository,
	ComunicationsRepository,
	UserRepository,
	ReportRepository,
	RecordRepository
};


// WEBPACK FOOTER //
// src/api/index.js